import api from '@/api';


const { $academic, $qSystem, $pricing, $sumadi } = api

export const { $types } = $pricing
export const { $exams } = $qSystem
export const { $ceos } = $academic
export const { $launchInstructor } = $sumadi
